exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".circle{z-index:-1;position:absolute}.circle .inner-circle{background-color:#fff;border-radius:50%;position:relative}.circle .inner-circle::before{border-radius:50%;content:\"\";background-image:linear-gradient(to bottom, #F7F7F7 0%, white 100%);width:166%;height:166%;top:-30%;left:-30%;position:absolute;z-index:-1}.medium{width:602px;height:602px}@media(max-width: 575px){.medium{width:400px;height:400px}}.medium .inner-circle{width:374px;height:374px}@media(max-width: 575px){.medium .inner-circle{width:200px;height:200px}}.large{width:1000px;height:1000px;top:-600px;left:90px}@media(max-width: 575px){.large{width:900px;height:900px;top:-30px;left:100px}}.large .inner-circle{width:1000px;height:1000px}@media(max-width: 575px){.large .inner-circle{width:700px;height:700px}}.large .inner-circle::before{background-image:linear-gradient(to bottom, #F7F7F7 60%, white 80%)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Helpers/Circles/Circle.scss
// module id = 7452
// module chunks = 13